import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { AdminHeader, DeleteButton } from "@/components/admin/AdminUI";
import { toast } from "sonner";

const TYPE_LABEL = { quote: "Quote", contact: "Contact", partner: "Partner" };

export default function Inquiries() {
  const qc = useQueryClient();
  const { data: items = [], isLoading } = useQuery({ queryKey: ["admin-inquiries"], queryFn: async () => (await api.get("/admin/inquiries")).data });

  const remove = async (id) => {
    await api.delete(`/admin/inquiries/${id}`);
    qc.invalidateQueries({ queryKey: ["admin-inquiries"] });
    toast.success("Inquiry deleted");
  };

  return (
    <div data-testid="manage-inquiries">
      <AdminHeader eyebrow="Leads" title="Inquiries" />

      {isLoading ? (
        <p className="text-[#5E5A54] font-light">Loading…</p>
      ) : items.length === 0 ? (
        <div className="bg-white border border-[#ECEAE4] p-12 text-center text-[#5E5A54] font-light" data-testid="inquiries-empty">
          No inquiries yet. New quote requests and contact submissions will appear here.
        </div>
      ) : (
        <div className="bg-white border border-[#ECEAE4] divide-y divide-[#ECEAE4]">
          {items.map((q) => (
            <div key={q.id} className="p-6 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-testid={`inquiry-${q.id}`}>
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-medium text-[#2C2A29]">{q.name || "Anonymous"}</span>
                  <span className="label-eyebrow text-[9px] px-2 py-1 bg-[#F6F5F2] text-[#9E8773]">{TYPE_LABEL[q.type] || q.type}</span>
                  {q.product_name && <span className="text-sm text-[#5E5A54] font-light">· {q.product_name}</span>}
                </div>
                <p className="text-sm text-[#5E5A54] font-light mt-1">
                  {q.email}{q.phone ? ` · ${q.phone}` : ""}
                </p>
                {q.message && <p className="text-[#2C2A29] font-light mt-2 max-w-2xl">{q.message}</p>}
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-[#9E8773] whitespace-nowrap">{new Date(q.created_at).toLocaleString()}</span>
                <DeleteButton onConfirm={() => remove(q.id)} label="inquiry" testid={`delete-inquiry-${q.id}`} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
